import React from 'react';
import {
  $BannerContent,
  $InnerBackground,
  $GlobeContainer,
  $ContentContainer,
  $TextContainer,
  $HeaderSection,
  $FeaturesList,
  $ButtonContainer,
  $RequestAccessButton,
  $ReadMoreButton,
} from './InternationalAvsPromotionBanner.styled';

interface Props {
  onTryNow: () => void;
  onReadDocumentation: () => void;
  isRequestButtonDisabled?: boolean;
}

const InternationalAvsPromotionBannerContent = ({
  onTryNow,
  onReadDocumentation,
  isRequestButtonDisabled = false,
}: Props) => (
  <$BannerContent>
      <$GlobeContainer>
        <img src="/images/accountVerification/globe-dotted.svg" alt="Globe with integrated verification pins" />
      </$GlobeContainer>

      <$InnerBackground />
      <$ContentContainer>
        <$TextContainer>
          <$HeaderSection>
            <span className="subtitle">ACCESS NEW COUNTRIES</span>
            <h2 className="title">Unlock Global Account Verification</h2>
          </$HeaderSection>
          <$FeaturesList>
            <li>Verify accounts in UAE, KSA, and 22+ countries</li>
            <li>Powered by trusted, official banking data</li>
            <li>Real-time responses, automated processes</li>
          </$FeaturesList>
        </$TextContainer>
        <$ButtonContainer>
          <$RequestAccessButton 
            onClick={() => !isRequestButtonDisabled && onTryNow()} 
            className={isRequestButtonDisabled ? 'disabled' : ''}
          >
            {isRequestButtonDisabled ? 'Request sent' : 'Request access'}
          </$RequestAccessButton>
          <$ReadMoreButton onClick={onReadDocumentation}>Read more</$ReadMoreButton>
        </$ButtonContainer>
      </$ContentContainer>
  </$BannerContent>
);

export default InternationalAvsPromotionBannerContent;
